<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3d6ICj/tc-custom/9780830862245.jpg?1696025618587" alt="This image is the cover for the book Revelation, LifeGuide Bible Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Revelation, LifeGuide Bible Studies
      </h1>
      <p class="bookDescription body article font2">
        <p>In every age people have felt certain that the book of Revelation described events in their time. As nations arm themselves for war, we think of Armageddon. As evil rulers grow in power, we look for the antichrist. As the powers of darkness threaten to overwhelm us, we cry, "Come, Lord Jesus!"  In this fourteen-session LifeGuide® Bible Study, R. Paul Stevens discusses amid the uncertainties of our age, Revelation assures us of the ultimate triumph of God. For over three decades LifeGuide Bible Studies have provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R. Paul Stevens
      </h2>
      
      <p class="authorDescription body article"><p>R. Paul Stevens is professor emeritus of marketplace theology and leadership at Regent College, Vancouver, British Columbia, and a marketplace ministry mentor. He has worked as a carpenter and businessman, and served as the pastor of an inner-city church in Montreal. He has written many books and Bible studies, including <em>Doing God's Business, Work Matters, Marriage Spirituality, The Other Six Days</em> and <em>Spiritual Gifts.</em> He is coauthor (with Pete Hammond and Todd Svanoe) of <em>The Marketplace Annotated Bibliography.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4bbc47c6